var itIT = {
	"codeBlock.copied": "Copiato",
	"codeBlock.copyLabel": "Copia",
	"inlineCodeBlock.copied": "Copiato",
	"inlineCodeBlock.copyLabel": "Copia codice in linea"
};

export { itIT as default };
